define(['jquery', 'common', 'gridalicious'], function ($, Common) {
	var Countries = function () {
		var self = this;

		self.$ervBody = $('#erv-body');
		self.$countrySearchContainer = self.$ervBody.find('#country-search');
		self.$countryTemplate = self.$ervBody.find('#country-template');
		self.common = new Common();

		self.availableTags = [];

		self.initTagIt = function (selector, data) {

			$(selector).tagit({
				availableTags: (data != undefined ? data : []),
				autocomplete: {
					delay: 0,
					minLength: 0,
					autoFocus: true
				},
				allowSpaces: true,
				allowDuplicates: false,
				allowNewTags: false,
				triggerKeys: ['enter', 'comma', 'tab'],
				tagLimit: 1,
				beforeTagAdded: function (event, ui) {
					return self.common.forms.ervTagit.tagitBeforeAdded(data, event, ui);
				},
				afterTagAdded: function (event, ui) {
					var tag = $.grep(self.availableTags, function (e) { return e.label == ui.tagLabel; })[0],
						html = self.$countryTemplate.html().replace(/{{value}}/g, tag.url);
					self.$countrySearchContainer.append($(html));
					self.$ervBody.find('#country-search-button').focus();
					self.common.forms.ervTagit.tagitAutocompleteEvents(false, $(event.target).parent());

				},
				afterTagRemoved: function (event, ui) {
					self.$countrySearchContainer.find("input[value='" + $.grep(self.availableTags, function (e) { return e.label == ui.tagLabel; })[0].url + "']").remove();
					self.$newTagitInput.attr('style', 'visibility:visible');
					self.common.forms.ervTagit.tagitAutocompleteEvents(true, $(event.target).parent());
				}
			});
			self.$newTagitInput = self.$countrySearchContainer.find('input.ui-autocomplete-input');
			self.$newTagitInput.attr('placeholder', self.$countrySearchContainer.data('placeholder'));

			self.common.forms.ervTagit.tagitAutocompleteEvents(true, $(selector).parent());
		};

		self.setupEventHandling = function () {
			self.initTagIt('#country-search-input', self.$ervBody.find('#country-search-input').parents('form').find('ul.hide li').map(function () {
				self.availableTags.push({ label: $(this).text(), url: $(this).data('value') });
				return $(this).text();
			}));

			self.initGridalicious('.stack');

			self.$ervBody.find('#country-search-button').on('click', function (e) {
				e.preventDefault();
				var $urlElement = self.$ervBody.find('#Country_Url');

				if ($urlElement.length > 0 && $urlElement.val().length > 0 && $urlElement.val() !== '{{value}}') {
					window.location = $urlElement.val();
				}
			});
		}

		self.initGridalicious = function (selector) {
			var $container = $('.gridalicious'),
				itemWidth = $container.data('stackwidth');

			if (typeof (itemWidth) === 'undefined')
				itemWidth = 250;

			$container.gridalicious({
				gutter: 1,
				width: itemWidth,
				selector: selector
			});
		};
	};

	Countries.prototype.init = function () {
		var self = this;

		self.setupEventHandling();
	}

	return Countries;
});